import { useContext, useEffect, useState } from "react";

export const useShippingPendingFooter = (props) => {
    return {};
};
